import React, { useState, useRef,useEffect, useCallback } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from 'react-i18next';
import API from '../../api/api.jsx';
import { useLocation } from 'react-router-dom';

const FileHeader = ({ title }) => (
    <div className="file-header col d-flex justify-content-center align-items-center">
        <p className="mb-0 font-weight-bold">{title}</p>
    </div>
);

const FileDetails = ({ children }) => (
    <div className="file-details col d-flex justify-content-center align-items-center" style={{ overflow: 'hidden' }}>
        {children}
    </div>
);

// 베트남 동 통화로 변환하는 함수 담보금액에 추가할 예정
function formatMoney(amount) {
	return new Intl.NumberFormat('vi-VN', {
		style    : 'currency',
		currency : 'VND',
	}).format(amount).replace(/[₫]/g,'').trim(); // 통화 기호만 제거
};

const Loan002_03 = ({loan_application_id, loan_status}) => {
	const location = useLocation();	
	const params = new URLSearchParams(location.search);
  	const loanApplicationId = params.get('loanApplicationId')	

	const { t } = useTranslation();
	const [selectOptions, setSelectOptions]           = useState([]);
	const [selectStorage, setSelectStorage]           = useState([]); //보관함			
	const [responseData, setResponseData]             = useState([]);

	const [saveBtn, setSaveBtn]       				  = useState('담보물정보 저장');

	const [hoveredAddBtn, setHoveredAddBtn] = useState(false); // "담보물 추가" 버튼의 상태 변수
	const [hoveredSaveBtn, setHoveredSaveBtn] = useState(false); // "담보물 정보 저장" 버튼의 상태 변수  

	

	const handleMouseEnterAddBtn = () => {
		setHoveredAddBtn(true);		//담보물 추가버튼 hover
	};	
	const handleMouseLeaveAddBtn = () => {
		setHoveredAddBtn(false);	//담보물 추가버튼 hover
	};
	
	const handleMouseEnterSaveBtn = () => {
		setHoveredSaveBtn(true);	//담보물 저장버튼 hover
	};	
	const handleMouseLeaveSaveBtn = () => {
		setHoveredSaveBtn(false);	//담보물 저장버튼 hover
	};
	
	const buttonStyleAddBtn = { //담보물 추가버튼 css
		backgroundColor: hoveredAddBtn ? '#286A45' : '#7DA390',
		color: '#FFFFFF',
	};
	
	const buttonStyleSaveBtn = { //담보물 저장버튼 css
		backgroundColor: hoveredSaveBtn ? '#286A45' : '#7DA390',
		color: '#FFFFFF',
	};

	const handleFileButtonClick = (index) => {
		// input 엘리먼트 클릭
		const fileInput = document.getElementById(`fileInput_${index}`);
		fileInput.click();
	};

	const handleSave = async (e) => {	
		console.log(responseData)
		let finally_loan_application_id = ''
		let file_seq = 0
		if(!loan_application_id){
			finally_loan_application_id = loanApplicationId
			// console.log(`링크 갑 ${finally_loan_application_id}`)
		}else{
			finally_loan_application_id = loan_application_id
			// console.log(`받은 갑 ${finally_loan_application_id}`)
		}
		const formData = new FormData()
		if(responseData.length == 0){			
			return
		}else if(!finally_loan_application_id){
			alert('대출정보가 존재하지 않아 승인요청 할 수 없습니다.')
			return		
		}else{
			let isEmpty = false; // 빈 값이 있는지 여부를 나타내는 플래그 변수
			for (const item of responseData) {				
				if (!item.collateralType || !item.modelName || !item.storage_id || !item.price || !item.file_names) {
				    isEmpty = true;
				    break; // 중요: 루프를 중단해야 하므로 break 사용
				}
			}			
			if (isEmpty) {
				alert(t(`LOAN_APPLICATION.가격, 모델명, 담보물종류, 보관소, 파일명은 필수입니다`, { defaultValue: '가격, 모델명, 담보물종류, 보관소, 파일명은 필수입니다' }));
				return;
			}			
			//현재 존재하는 responseData에 필요한 값 추가
			for (const item of responseData) {
				if (!item.id) {
			        item.id = '';
				}
				if (!loan_application_id) {
				    item.loanApplicationId = loanApplicationId;
				} else {
				    item.loanApplicationId = loan_application_id;
				}

				formData.append(`seq`, item.sequence);
				formData.append(`id`, item.id);
				formData.append(`loan_application_id`, item.loanApplicationId);
				formData.append(`collateral_type`, item.collateralType);
				formData.append(`model`, item.modelName);
				formData.append(`storage_id`, item.storage_id);
				formData.append(`price`, item.price);
				formData.append(`remark`, item.remark);
			
				if (item.files instanceof FileList && item.file_names.length !== 0) {
					for (let i = 0; i < item.files.length; i++) {
						formData.append(`file_${file_seq}`, item.files[i]);
					}
				}
				
				// file_list 번호를 매기기 위한 값
				file_seq = file_seq + 1
			}

			try {
				const response = await API.fetchLoan00203DataPOST({
					formData					
				});

				alert(t(`LOAN_APPLICATION.담보물정보가 저장 되었습니다`, { defaultValue: '담보물정보가 저장 되었습니다' }));

			}catch (error) {
					console.error('담보물 저장 에러:', error);
			}   
		}

	}

	// 이 함수는 인덱스를 받아 해당 인덱스의 row를 삭제합니다.
	const handleDeleteRow = (index) => {
		const updatedData = [...responseData];
		updatedData.splice(index, 1); // 해당 인덱스의 요소를 삭제합니다.
		setResponseData(updatedData); // 업데이트된 데이터를 설정합니다.
	};

	const handleFileChange = (e, index) => {

		const files = e.target.files;
		
		if (files.length > 0) {
			const validExtensions = ['jpg', 'jpeg', 'png', 'pdf'];
			const invalidFiles = Array.from(files).filter(
				file => !validExtensions.includes(file.name.split('.').pop().toLowerCase())
			);
			
			if (invalidFiles.length > 0) {
				alert('JPG, JPEG, PNG, PDF 확장자만 허용됩니다..');
				return; // 잘못된 확장자가 포함된 경우 처리 중단
			}
			
			const fileNames = Array.from(files).map(file => file.name).join(', ');
			const updatedData = responseData.map((item, i) => {
				if (index === i) {
					return { ...item, files: files, file_names: fileNames }; // files 속성을 해당 항목에 추가
				}
				return item;
		    });
		    setResponseData(updatedData);
		}
	};

	//모델명
	const handleModelNameChange = (e, index) => {
		const { value } = e.target;
		const updatedData = responseData.map((item, i) => {
			if (index === i) {
				return { ...item, modelName: value };
			}
			return item;
		});
		setResponseData(updatedData);
	};
	//보관소
	const handleStorageTypeChange = (e, index) => {
		const { value } = e.target;
		const updatedData = responseData.map((item, i) => {
			if (index === i) {
				return { ...item, storage_id: value };
			}
		return item;
		});
		setResponseData(updatedData);
	};
	//적요
	const handleRemarkChange = (e, index) => {
		const { value } = e.target;
		const updatedData = responseData.map((item, i) => {
		if (index === i) {
			return { ...item, remark: value };
		}
		return item;
		});
		setResponseData(updatedData);
	};
	//담보금액
	const handlePriceChange = (e, index) => {
		const { value } = e.target;
		const updatedData = responseData.map((item, i) => {
			if (index === i) {
				return { ...item, price: value };
			}
			return item;
		});
		setResponseData(updatedData);
	};
	//담보종류
	const handleCollectralTypeChange = (e, index) => {
		console.log(e.value)
		const { value } = e.target;
		const updatedData = responseData.map((item, i) => {
			if (index === i) {
				return { ...item, collateralType: value };
			}
		return item;
		});
		setResponseData(updatedData);
	};

	useEffect(() => {		
        const fetchBaseOptions = async () => {
            try {
                const data     = await API.fetchBaseOptions();
                const options  = data.filter(item => item.code_nick_name === '담보물종류');
				const result   = options.flatMap(item => item.code);
                // const result   = options.map(item => [item.code]);

                setSelectOptions(result);
                
            } catch (error) {
                console.error('Error fetching Base Options data:', error);
            }
			
        };
			
		// 보관함 정보 호출 API
		const fetchLoan00203Data = async () => {
			try {
				const data           = await API.fetchLoan00203Data({});
				const translatedData = []

				// 데이터 배열을 순회하며 storage_id와 location 저장
				for (let i = 0; i < data.length; i++) {
					const storageOption = {
						storage_id : data[i].storage_id,
						name       : data[i].name
					};						
					translatedData.push(storageOption);
				}
				setSelectStorage(translatedData);
				
			} catch (error) {
				console.error('Error fetching storage data:', error);
			}
		};	
		
		if(loanApplicationId){			
			const fetchLoan00203SelectData = async () => {
				try {
					const data = await API.fetchLoan00203SelectData({
						'loanApplicationId': loanApplicationId
					});

					const translatedData = data.map((item, index) => {		
					
						return {
							id			  : item.collateral_id,
							sequence	  : index + 1,
							collateralType: item.collateral_type, 	// 동적으로 설정하거나 API 응답에서 가져오기
							modelName     : item.model, 			// 동적으로 설정하거나 API 응답에서 가져오기
							storage_id    : item.storage_id,
							price 	      : item.price,
							remark        : item.remark,
							file_names    : item.file_names,
						};
					});
					// setResponseData([...responseData, ...translatedData]);
					setResponseData(translatedData);
					setSaveBtn('담보물정보 수정')

				} catch (error) {
					console.error('Error fetching storage data:', error);
				}
			};
			fetchLoan00203SelectData();
		}		
		
        fetchBaseOptions();
		fetchLoan00203Data(); //담보물정보 보관소
    }, []);

	const handleAddRow = () => { //담보물 추가 버튼 빈 row 추가
		if(!selectStorage[0]){
			alert(t('LOAN_APPLICATION.보관소가 등록되어있지 않습니다', { defaultValue: '보관소가 등록되어있지 않습니다' }))
			return
		}
		const newRow = { 
			sequence: responseData.length + 1,// 새로운 행의 순번 설정
			collateralType : 'XM',// 내용 초기값 설정
			modelName : '',
			storage_id : selectStorage[0].storage_id,
			price: '',
			remark: '', 
		};
		setResponseData([...responseData, newRow]);
	};	
	return (
		<div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordion">
			<div className="accordion-body bg-white text-gray-900">
				<div className="justify-content-end">
					<button type="button" className="btn text-white" style={buttonStyleAddBtn} onMouseEnter={handleMouseEnterAddBtn} onMouseLeave={handleMouseLeaveAddBtn}  onClick={handleAddRow}>
							{t('LOAN_APPLICATION.담보물추가', { defaultValue: '담보물추가' })}+
					</button>
				</div>
				<div>
					<div className="row mb-2">
						<div className='row'>
							<div className="col-md-1">
								<FileHeader title= {t('SMS_MANAGEMENT.순번', { defaultValue: '순번' })} />														
							</div>

							<div className="col-md-2">
								<FileHeader title= {t('LOAN_APPLICATION.담보물종류', { defaultValue: '담보물종류' })} />
							</div>							

							<div className="col-md-1">
								<FileHeader title= {t('LOAN_APPLICATION.모델명', { defaultValue: '모델명' })} />						
							</div>							

							<div className="col-md-2">
								<FileHeader title= {t('LOAN_APPLICATION.보관소', { defaultValue: '보관소' })} />						
							</div>							

							<div className="col-md-1">
								<FileHeader title= {t('LOAN_APPLICATION.담보금액', { defaultValue: '담보금액' })} />						
							</div>							

							<div className="col-md-2">
								<FileHeader title= {t('LOAN_APPLICATION.적요 (Remarks)', { defaultValue: '적요 (Remarks)' })} />						
							</div>							

							<div className="col-md-3">
								<FileHeader title= {t('LOAN_APPLICATION.파일명', { defaultValue: '파일명' })} />						
							</div>							
						</div>
					</div>

					<ul className="list-group">
						{responseData.length === 0 ? (
							<li className="list-group-item text-center">{t('LOAN_APPLICATION.등록된 담보물이 없습니다.', { defaultValue: '등록된 담보물이 없습니다.' })}</li>
						) : (
							responseData.map((item, index) => 
							<li key={index} className="list-group-item">														
								
    							<input value={item.collateral_id}  style={{ display: 'none' }} />
								<div className="row align-items-center">
									<div className="col-md-1">
										<FileDetails style={{ width: '10%' }}>{item.sequence}</FileDetails>
									</div>
									{/* 담보물종류 */}
									<div className="col-md-2">
										<FileDetails style={{ width: '20%' }}> 
											<select className="form-select form-select-sm" value={item.collateralType} onChange={(e) => handleCollectralTypeChange(e, index)}>
												{selectOptions.map((option, index) => (
													<option key={index} value={option}>
														{t(`COLLATERAL.${option}`, { defaultValue: `${option}` })}
													</option>
												))}
											</select>
										</FileDetails>
									</div>

									{/* 모델명 */}
									<div className="col-md-1">
										<FileDetails>
											<input className="form-control form-control-sm" type="text" value={item.modelName} onChange={(e) => handleModelNameChange(e, index)}/>
										</FileDetails>
									</div>
									{/* 보관소 */}
									<div className="col-md-2">
										<FileDetails style={{ width: '20%' }}> 
											<select className="form-select form-select-sm" value={item.storage_id} onChange={(e) => handleStorageTypeChange(e, index)}>												
												{selectStorage.map((option, index) => (	
													<option key={index} value={option.storage_id}>
														{option.name}
													</option>
												))}
											</select>
										</FileDetails>
									</div>

									{/* 담보금액 */}
									<div className="col-md-1">
										<FileDetails> 
											<input className="form-control form-control-sm text-end" type="text" value={item.price} onChange={(e) => handlePriceChange(e, index)}/>
										</FileDetails>
									</div>

									{/* 적요 */}
									<div className="col-md-2">
										<FileDetails> 
											<input className="form-control form-control-sm" type="text" value={item.remark} onChange={(e) => handleRemarkChange(e, index)}/>
										</FileDetails>
									</div>

									{/* 파일명 */}								
									<div className="col-md-3">
										<FileDetails> 
											{/* <input className="form-control form-control-sm" type="file" onChange={(e) => handleFileChange(e, index)} multiple /> */}
											<input
												type="text"
												className="form-control form-control-sm"
												value={item.file_names || 'No Data.'}
												readOnly
											/>
											<button onClick={() => handleFileButtonClick(index)} className="btn"><i className="fa-solid fa-upload"></i></button>
											<input
												id={`fileInput_${index}`}
												className="form-control form-control-sm"
												type="file"
												style={{ display: 'none' }}
												onChange={(e) => handleFileChange(e, index)}
												accept=".jpg, .jpeg, .png, .pdf" // 확장자 지정
												multiple
											/>
											<button onClick={() => handleDeleteRow(index)} className="btn ml-2">X</button>
										</FileDetails>
									</div>
								</div>
							</li>))
						}
					</ul>
				</div>
				<div className = "p-1 pt-2 d-flex justify-content-center">
					{loan_status === '' || loan_status === 'S01' || loan_status ==='S04' || loan_status ==='S06' ?(
						<button type="button" className="btn text-white" style={buttonStyleSaveBtn} onMouseEnter={handleMouseEnterSaveBtn} onMouseLeave={handleMouseLeaveSaveBtn} onClick={handleSave}>
							{t(`LOAN_APPLICATION.${saveBtn}`, { defaultValue: saveBtn })}
						</button>
					) : null}
				</div>
			</div>
		</div>
	);
};

export default Loan002_03;